import styled from 'styled-components';
import breakpoints from 'utils/breakpoints';

const Section = styled.section.attrs(({ className, wScreen = 'w-screen' }) => ({
  className: `flex flex-col items-center justify-start ${
    className || ''
  } ${wScreen}`,
}))`
  ${({ noPaddingMobile }) =>
    noPaddingMobile
      ? `
        padding-top: 0;
        padding-bottom: 0;
      `
      : `
        padding-top: 1.563rem;
        padding-bottom: 1.563rem;
      `}
  @media ${breakpoints.lg} {
    ${({ noPaddingMobile }) =>
      noPaddingMobile
        ? `
          padding-top: 0;
          padding-bottom: 0;
        `
        : `
          padding-top: 3.125rem;
          padding-bottom: 3.125rem;
        `}
  }

  ${({ bottomOverlap }) =>
    bottomOverlap &&
    `
    @media ${breakpoints.lg} {
      padding-bottom: 7.5rem !important;
    }
  `}
`;

export default Section;
